import shiftReducer from './reducers';

export { default as shiftActions } from './actions';
export { default as shiftOperations } from './operations';
//export { default as dashboardShapes } from './shapes';

export default shiftReducer;
